import React from 'react';
import { GrammarlyButton } from '@grammarly/editor-sdk-react';
import environment from '../environment';

const GrammarlyButtonWrapper = () => {
  return environment.grammarly.clientId ? <GrammarlyButton /> : null;
};

export default GrammarlyButtonWrapper;
